import { useMemo } from "react";
import { useGetMembersQuery, useGetPlansQuery } from "../services/api.js";
import { Member, Plan } from "../../server/ps/index.js";

export type MemberWithPlan = Omit<Member, "birth"> & {
    birth: Date;
    plan: Plan;
};

export default function useMemberWithPlans() {
    const { data: members = [], isLoading: membersIsLoading } =
        useGetMembersQuery({});
    const { data: plans = [], isLoading: plansIsLoading } = useGetPlansQuery(
        {}
    );

    const isLoading = membersIsLoading || plansIsLoading;

    const membersWithPlans = useMemo(() => {
        const mergedMembers = [];

        for (const plan of plans) {
            const planMembers = [];
            for (const member of members) {
                if (member.subscriberNumber === plan.subscriberNumber) {
                    planMembers.push(member);
                    //Add plan to member
                    const mergedMember = {
                        ...member,
                        plan: plan,
                    };
                    mergedMembers.push(mergedMember);
                }
            }
        }

        return mergedMembers;
    }, [members, plans]) as MemberWithPlan[];

    return { data: membersWithPlans, isLoading: isLoading };
}
